export default __webpack_public_path__ + "static/logo_goldvertrauen-f88be8f97dbe5787ddba29656e10671c.svg";